import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";
import { isTruthy } from "~/tools/is-truthy";

import { StatChartFormState } from "../../../components/widget-form/stat-chart-form-state";
import { dashboardWidgetFormatSchema } from "../_dashboard-widget-format";
import { dashboardWidgetLinks } from "../_dashboard-widget-link";
import { dashboardWidgetThresholds } from "../_dashboard-widget-threshold";

import { timeSeriesQueries } from "./_time-series-query";

export const statChartSchema = z
	.object({
		plugin: z.object({
			kind: z.literal("StatChart"),
			spec: z
				.object({
					calculation: z.enum(ALL_CALCULATIONS).optional().catch(undefined),

					format: dashboardWidgetFormatSchema.optional().catch(undefined),

					sparkline: z.unknown().transform(isTruthy).optional().catch(undefined),

					metricLabel: z.string().trim().optional().catch(undefined),

					valueFontSize: z.number().optional().catch(undefined),

					thresholds: z
						.object({
							defaultColor: z
								.string()
								.trim()
								.optional()
								.catch(undefined)
								.transform((color) => color || StatChartFormState.default.color),
							steps: dashboardWidgetThresholds,
						})
						.optional()
						.catch(undefined),
				})
				.catch({}),
		}),

		queries: timeSeriesQueries,

		links: dashboardWidgetLinks,
	})
	.transform(({ plugin, queries, links }) => ({ ...plugin, queries, links }));

export type StatChart = z.infer<typeof statChartSchema>;
